<div class="flex flex-col px-6 py-7">
  <div class="flex items-center justify-between mb-6">
    <p class="text-2xl font-bold text-sigecom-dark-gray">Sorteios</p>
    <div class="flex items-center gap-2">
      <ng-container *ngTemplateOutlet="filters"></ng-container>
      <sigecom-button
        title="CADASTRAR SORTEIOS"
        icon="clipboard"
        (buttonClicked)="navigateToCreate()"
      />
    </div>
  </div>
  <sigecom-total-records-list [totalRecords]="drawsPage?.totalElements" [label]="'Sorteios'"  />

  <ng-container *ngIf="drawsPage && drawsPage.content?.length; else empty">
    <sigecom-list-container>
      <sigecom-list-item *ngFor="let item of drawsPage.content;">
        <div class="flex items-center justify-between">
          <div class="flex flex-col gap-2">
            <sigecom-list-title [text]="item.sorTxNome!"/>

            <div class="flex">
              <sigecom-list-info info="Categoria" value="{{ item.catTxNome }}" />
            </div>
          </div>

          <sigecom-menu-bar>
            <sigecom-menu-bar-item title="Editar" icon="pen" color="sigecom-info" (clickAction)="navigateToEdit(item)"/>
            <sigecom-menu-bar-item title="Gerar senha do usuário" icon="print" color="sigecom-info" (clickAction)="print(item)"/>
            <sigecom-menu-bar-item title="Excluir" icon="trash" color="sigecom-danger" />
          </sigecom-menu-bar>
        </div>
      </sigecom-list-item>
    </sigecom-list-container>

    <sigecom-pagination-list
      *ngIf="drawsPage.content?.length"
      class="mt-7"
      [totalPages]="drawsPage.totalPages!"
      [maxDisplayedPages]="10"
      (pageChange)="onPageChange($event)"
    />
  </ng-container>

  <ng-template #empty>
    <sigecom-not-found-message-list message="Nenhum sorteio encontrado" />
  </ng-template>
</div>

<sigecom-confirmation-modal />

<ng-template #filters>
  <sigecom-offcanvas>
    <ng-template>
    <div class="flex flex-col gap-4">

      <sigecom-input-search placeholder="Pesquisar por nome..." (searchChange)="filterByName($event)" />

      <!-- <sigecom-input-container label="Categoria" [type]="InputTypeEnum.SELECT" [isDisabled]="false">
        <select sigecom-input name="catNrId" #selectedCat (change)="filterByCategory(selectedCat.value)">
          <option [ngValue]="undefined">Selecione...</option>
          <option *ngFor="let category of categoriesList" [value]="category">
            {{ category }}
          </option>
        </select>
      </sigecom-input-container> -->
    </div>
   </ng-template>
  </sigecom-offcanvas>
</ng-template>
